import { useAuthStore } from '../stores/authStore'
import { setAuthToken, getAuthToken } from './authStorage'

/** Bearer marker for Vite-only local shell — never sent as a real API credential. */
export const DEV_LOCAL_SHELL_TOKEN = 'zimark-dev-local-shell'

export function isDevLocalShellSession(): boolean {
  return Boolean(import.meta.env.DEV && getAuthToken() === DEV_LOCAL_SHELL_TOKEN)
}

/**
 * DEV-only: land in the real student shell (/messages + DashboardLayout)
 * without Google/captcha. API calls may 401; session must not auto-logout.
 */
export function enterDevLocalStudentShell(): void {
  if (!import.meta.env.DEV) return
  setAuthToken(DEV_LOCAL_SHELL_TOKEN, true)
  useAuthStore.getState().login({
    id: 'dev-local-student',
    email: 'dev@localhost',
    firstName: 'Dev',
    lastName: 'Student',
    role: 'student',
    emailVerified: true,
    onboardingCompleted: true,
    needsOnboarding: false,
  })
}
